"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLoading = exports.PaperIconCache = void 0;
var api_1 = require("./api");
var fallbackIcons_1 = require("./fallbackIcons");
/**
 * Caches icons to de-duplicate identical simultaneous requests and to enable pre-fetching icons
 */
var PaperIconCache = /** @class */ (function () {
    function PaperIconCache(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.unitTestMode, unitTestMode = _c === void 0 ? (typeof jest !== 'undefined') : _c;
        this._cache = {};
        this._unitTestMode = unitTestMode;
    }
    PaperIconCache.prototype.clearAll = function () {
        this._cache = {};
    };
    /**
     * Fetches an icon from the cache. Can also be used for pre-fetching
     *
     * @param collection - Name of the collection
     * @param env - String enum of the environment
     * @param fetch - Fetch function (window.fetch) to use to get the icon
     * @param name - Name of the icon itself
     * @return A promise that resolves with the icon data, or the actual icon data if available immediately
     */
    PaperIconCache.prototype.getIcon = function (_a) {
        var _b;
        var collection = _a.collection, _c = _a.fetch, fetch = _c === void 0 ? api_1.defaultFetch : _c, env = _a.env, name = _a.name;
        var iconUrl = (0, api_1.buildIconJsonUrl)(env, collection, name);
        var loadable = (_b = this._cache[iconUrl]) !== null && _b !== void 0 ? _b : (this._cache[iconUrl] = {});
        // Return synchronously if data is already loaded
        if (loadable.data) {
            return loadable.data;
        }
        // Don't fetch anything during unit tests
        if (this._unitTestMode) {
            return fallbackIcons_1.FAKE_TEST_WARNING_ICON;
        }
        // Otherwise, we have to fetch the icon
        if (!loadable.promise) {
            // Cache the Promise to de-duplicate identical requests
            loadable.promise = (0, api_1.fetchIconFromUrl)(iconUrl, fetch);
            loadable.promise
                .then(function (data) {
                // After the icon loads, attach it to the object so subsequent requests can return synchronously
                loadable.data = data;
            }, function ( /* error */) {
                // Do nothing (returns undefined) so that the Promise runtime thinks the rejection has been handled.
                // This is necessary for the Jest unit tests, where having an unhandled promise rejection
                // seems to cause it to error-out
            })
                .then(function () {
                // (Since this block comes after a no-op error handler, it's effectively "finally")
                // Delete the promise after the server result comes back because it's no longer needed
                loadable.promise = undefined;
            });
        }
        return loadable.promise;
    };
    return PaperIconCache;
}());
exports.PaperIconCache = PaperIconCache;
/**
 * Interpret whether cache.getIcon returned a Promise (indicating it's loading asynchronously) or a loaded icon
 */
function isLoading(thing) {
    return typeof thing.then === 'function';
}
exports.isLoading = isLoading;
//# sourceMappingURL=PaperIconCache.js.map